// extracted by mini-css-extract-plugin
export default {"variantPage":"OWRe5rKfUC","variantContent":"EEKPUk9aZE"};